/**
 * @generated SignedSource<<38ed24471eed444b883fe1513472aeff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSubmitButton_viewer$data = {
  readonly isFineGrainedCheckoutErrorsEnabled: boolean | null;
  readonly isMultiStageCheckoutOn: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"applePayCheckout_viewer" | "checkoutSubmitActions_viewer">;
  readonly " $fragmentType": "CheckoutSubmitButton_viewer";
};
export type CheckoutSubmitButton_viewer$key = {
  readonly " $data"?: CheckoutSubmitButton_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSubmitButton_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSubmitButton_viewer",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "checkoutSubmitActions_viewer",
      "selections": [
        {
          "alias": "disable3dsVerificationForCheckout",
          "args": [
            {
              "kind": "Literal",
              "name": "key",
              "value": "disable3dsVerificationForCheckout"
            }
          ],
          "kind": "ScalarField",
          "name": "isEnabled",
          "storageKey": "isEnabled(key:\"disable3dsVerificationForCheckout\")"
        },
        {
          "alias": "default3dsAuthorizationAmountToOne",
          "args": [
            {
              "kind": "Literal",
              "name": "key",
              "value": "zero3dsAmounts"
            }
          ],
          "kind": "ScalarField",
          "name": "isEnabled",
          "storageKey": "isEnabled(key:\"zero3dsAmounts\")"
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "applePayCheckout_viewer",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Token",
          "kind": "LinkedField",
          "name": "clientToken",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "alias": "isMultiStageCheckoutOn",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "multiStageCheckout"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"multiStageCheckout\")"
    },
    {
      "alias": "isFineGrainedCheckoutErrorsEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "fineGrainedCheckoutErrors"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"fineGrainedCheckoutErrors\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "2362bed1add9cc600d7350360aba8d10";

export default node;
